export default __webpack_public_path__ + "assets/Beachfront.0bf3fa9d.png";